import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'

document.addEventListener('DOMContentLoaded', function() {
  // Array.from(document.querySelectorAll('[data-donation]')).forEach((donationElement) => {
  //   const container = document.createElement('div')
  //   container.classList.add('donation-wrapper');
  //   donationElement.after(container)
  //   const root = createRoot(container);
  //   root.render(<App campaignId={donationElement.getAttribute('data-campaign') || (window as any).UWBC_DEFAULT_DONATION_CAMPAIGN} donationTileId={donationElement.getAttribute('data-tile-id') || undefined} useCookies={donationElement.getAttribute('data-use-cookies') == "true" || false} baseUrl={baseUrl} />);
  //   donationElement.remove();
  // })
  Array.from(document.querySelectorAll('[data-payments]')).forEach(element => {
    const root = createRoot(element);
    root.render(<App />);
  })
})